import { LOGIN_USER, SET_ACTIVE_DROPDOWN } from '../actions/general';

const defaultUserState = {
  email: null,
  firstName: null,
  lastName: null,
  isActive: null,
};

const defaultState = {
  activeDropdown: null,
  user: defaultUserState,
};

const generalReducer = (state = defaultState, action) => {
  switch (action.type) {
    case LOGIN_USER:
      return {
        ...state,
        user: action.payload,
      };
    case SET_ACTIVE_DROPDOWN:
      return {
        ...state,
        activeDropdown: action.payload,
      };
    default:
      return state;
  }
};

export default generalReducer;
